<template>
  <RevLink
    class="hidden text-nowrap px-12 py-8 md:block"
    target="_blank"
    :to="`https://pro${market.domain}/?utm_source=${UTM_SOURCE}&utm_medium=${UTM_MEDIUM}&utm_campaign=${UTM_CAMPAIGN}&utm_content=${UTM_CONTENT}`"
    :tracking="{ name: 'bm4b_header_button', zone: 'header' }"
    :underlined="false"
    >{{ i18n(translations.bmProButtonText) }}</RevLink
  >
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevLink } from '@ds/components/Link'

import translations from './BmProButton.translations'

const i18n = useI18n()
const { market } = useMarketplace()

const UTM_SOURCE = 'bm_b2c_header'
const UTM_MEDIUM = 'website'
const UTM_CAMPAIGN = `LIF_B2B_ALL_${market.countryCode}_INAP_BM4BConvergenceRedirection`
const UTM_CONTENT = 'header'
</script>
